module.exports = __webpack_public_path__ + "1bcbf2454d0213162c5eb9768be2689c.svg";